import Icon from "@core-components/icon/Icon";
import type {
  ICardClassNames,
  InfoCardProps,
} from "@core-components/info-card/InfoCard";
import InfoCardGrid from "@core-components/info-card/InfoCardGrid";
import SSHeadline from "@core-components/title/SSHeadline";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Stack, Text } from "@mantine/core";
import HelpCenterReadMoreButton from "@modules/help-center/components/HelpCenterReadMoreButton";

const HelpCenterInfoCards = () => {
  const { t } = useAppTranslation("pages.support.helpCenterInfoCards");
  const { locationUrlBuilder } = useAppLanguage();

  const icon = <Icon.QuestionMark />;
  const classNames: ICardClassNames = {
    title: "font-secret-black",
    text: "!text-start",
    root: "!shadow-2xl no-underline",
  };

  const cards: InfoCardProps[] = [
    {
      to: locationUrlBuilder(EPublicRoutes.FAQ_CHANGE_EMAIL),
      icon,
      classNames,
      title: t("cards.email.title"),
      text: t("cards.email.text"),
      button: <HelpCenterReadMoreButton />,
    },
    {
      to: locationUrlBuilder(EPublicRoutes.FAQ_CHANGE_RIOT_ID),
      icon,
      classNames,
      title: t("cards.riotId.title"),
      text: t("cards.riotId.text"),
      button: <HelpCenterReadMoreButton />,
    },
    {
      to: locationUrlBuilder(EPublicRoutes.FAQ_GET_SKINS),
      icon,
      classNames,
      title: t("cards.skins.title"),
      text: t("cards.skins.text"),
      button: <HelpCenterReadMoreButton />,
    },
    {
      to: locationUrlBuilder(EPublicRoutes.FAQ_CANNOT_BUY_CHAMPIONS),
      icon,
      classNames,
      title: t("cards.champions.title"),
      text: t("cards.champions.text"),
      button: <HelpCenterReadMoreButton />,
    },
    {
      to: locationUrlBuilder(EPublicRoutes.FAQ_SAVE_SETTINGS),
      icon,
      classNames,
      title: t("cards.settings.title"),
      text: t("cards.settings.text"),
      button: <HelpCenterReadMoreButton />,
    },
    {
      to: locationUrlBuilder(EPublicRoutes.FAQ_ACCOUNT_BANNED),
      icon,
      classNames,
      title: t("cards.banned.title"),
      text: t("cards.banned.text"),
      button: <HelpCenterReadMoreButton />,
    },
  ];

  return (
    <Stack align="center">
      <Stack className="mb-9">
        <SSHeadline
          props={{
            title: {
              fz: 35,
            },
          }}
        >
          <SSLoLGradientText>{t("title")}</SSLoLGradientText>
        </SSHeadline>
        <Text className="font-inter text-lg text-primary-light-text">
          {t("subTitle")}
        </Text>
      </Stack>
      <InfoCardGrid cards={cards} />
    </Stack>
  );
};

export default HelpCenterInfoCards;
